<ion-item>

  <ion-label>
    <div class="data">
      <yu-icon slot="start" name="hash"></yu-icon>
      <span>{{ reference }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="calendar"></yu-icon>
      <span>{{ date | date: 'dd/MM/yyyy HH:mm' }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="map-pin"></yu-icon>
      <span>{{ location }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="user"></yu-icon>
      <span>{{ user }}</span>
    </div>
  </ion-label>

  <ion-note slot="end">
    <yu-tag [color]="colorState">{{ state }}</yu-tag>
  </ion-note>

</ion-item>
